import { fork, all } from "redux-saga/effects";
import dataSaga from "../Slice/DataSlice/saga";
import newsSaga from "../Slice/NewsSlice/saga";
import userSaga from "../Slice/UserSlice/saga";
import historySaga from "../Slice/HistorySlice/saga";
import sourceGenreSaga from "../Slice/NewsSlice/saga";
import socialMediaSaga from "../Slice/SocialMediaSlice/saga";
import reportNewsSaga from "../Slice/ReportNewsSlice/saga";
// import { watchToggleSaga } from "../Slice/InstanceSlice/saga";

function* rootSaga() {
  yield all([
    fork(dataSaga),
    fork(newsSaga),
    fork(userSaga),
    fork(historySaga),
    fork(sourceGenreSaga),
    fork(socialMediaSaga),
    fork(reportNewsSaga),
    // fork(watchToggleSaga),
  ]);
}

export default rootSaga;
